import lookups from '@/assets/json/clientLookups.json'
import { useFormStore } from '@/stores/form'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'
import router from '@/router'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

const modifyMobileNumber = () => {
  const formStore = useFormStore()

  const { requireMobileNumberEdit, currentMobileNumber, newMobileNumber } = formStore.form.values

  if (!currentMobileNumber || !newMobileNumber) {
    doNotify(
      i18n.global.t('pleaseSelectMobileNumberFirst'),
      i18n.global.t('pleaseSelectMobileNumberFirst'),
      undefined,
      'error'
    )
  }

  if (
    requireMobileNumberEdit &&
    currentMobileNumber &&
    newMobileNumber &&
    formStore.extraMap.showSubmitButton
  ) {
    return true
  }
}

const modifyEmailNumber = () => {
  const formStore = useFormStore()

  const { requireEmailEdit, currentEmail, newEmail } = formStore.form.values
  if (requireEmailEdit && currentEmail && newEmail && formStore.extraMap.showSubmitButton) {
    return true
  } else {
    doNotify(i18n.global.t('pleaseInsertOtp'), i18n.global.t('pleaseInsertOtp'), undefined, 'error')
  }
}

export default async function () {
  const formStore = useFormStore()

  const { requireMobileNumberEdit, enableAddressControls, requireEmailEdit } = formStore.form.values

  if (enableAddressControls != 2 && !requireMobileNumberEdit && !requireEmailEdit) {
    return false
  }

  if (enableAddressControls == 2) {
    return true
  }

  if (requireMobileNumberEdit) {
    return modifyMobileNumber()
  }
  if (requireEmailEdit) {
    return modifyEmailNumber()
  }

  return true
}
